
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';
import moment from "moment";

@Component
export class VisitsTableMix extends Vue {
    

    get extColumns(): ITableColumn[] {
    return  [
        {
            title: '',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: '',
            key: 'type',
            dataIndex: 'type',
        },
        {
            title: '',
            key: 'price_first',
            dataIndex: 'price_first',
        },
    ];
}
    
    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Дата визита"),
                key: '0',
                dataIndex: 'visit_dt',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            // {
            //     title: 'Позиция',
            //     key: '1',
            //     dataIndex: 'services_name.name',
            // },
            {
                title: i18nText("Косметолог"),
                key: '2',
                dataIndex: 'staff.name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            // {
            //     title: 'Тип',
            //     key: '3',
            //     dataIndex: 'type',
            //     scopedSlots: { customRender: 'type' },
            // },
            // {
            //     title: 'NPS',
            //     key: '4',
            //     dataIndex: 'TestTEST5',
            // },
            // {
            //     title: 'Статус',
            //     key: "5",
            //     dataIndex: "status.name",
            //     scopedSlots: { customRender: 'active' },
            // },
            {
                title: i18nText("Итого"),
                key: "6",
                dataIndex: "order.sum",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    } 
}
